import RouteCheckerTo from '@/views/route-checker';
import AxisSettings from './axis/axis-settings.view.vue';
import QuadrantSettings from './quadrant/quadrant-settings.view.vue';

export default [
  {
    path: '/nine-box/axis-settings',
    component: AxisSettings,
    name: 'Configurações dos Eixos',
    beforeEnter: RouteCheckerTo.hasAccessAxisSettings,
  },
  {
    path: '/nine-box/quadrant-settings',
    component: QuadrantSettings,
    name: 'Configurações dos Quadrantes',
    beforeEnter: RouteCheckerTo.hasAccessQuadrantSettings,
  },
]
